import styled from 'styled-components';

import { Flex } from '@amzn/storm-ui';

export const ActionList = styled.ul`
  list-style: none;
  margin: 0;
  padding: ${({ theme }) => theme.spacing.xxsmall.default} 0;
  min-width: 11.25rem;
`;

export const ActionItem = styled.li`
  margin: 0;
  padding: 0;
`;

export const ActionItemButton = styled.button`
  display: block;
  width: 100%;
  padding: ${({ theme }) => theme.spacing.xsmall.default} ${({ theme }) => theme.spacing.small.default};
  background: none;
  border: none;
  cursor: pointer;
  white-space: nowrap;
  font-size: 0.875rem;

  &:hover {
    background-color: ${({ theme }) => theme.color.gray[100]};
  }
`;

export const CardActionsFlex = styled(Flex)`
  column-gap: ${({ theme }) => theme.spacing.small.default};
  align-items: center;
`;
